<div class="small" *ngIf="driveRows.length > 0">
  <i>Суммарный пробег: {{ distanceForView(sumDistance) }}км. </i>
  <i *ngFor="let row of driveRows">{{ row.label }}: {{ row.distance }}км. </i>
</div>
<div class="small" *ngIf="zoneRows.length > 0">
  <i *ngFor="let row of zoneRows">Зона {{ row.zone }}км: {{ row.cost }}р. </i>
</div>
